import styled, { css } from "styled-components";
import { TColor } from "../theme";

export const ColorCircle = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  display: inline-flex;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  margin-right: 8px;
`;

export const Highlight = styled.mark<{
  $color?: TColor;
  $backgroundColor?: TColor;
  $fontFamily?: React.CSSProperties["fontFamily"];
  $padding?: React.CSSProperties["padding"];
  $margin?: React.CSSProperties["padding"];
  $borderRadius?: React.CSSProperties["borderRadius"];
  $fontWeight?: React.CSSProperties["fontWeight"];
}>`
  color: ${({ theme, $color }) => theme.colors[$color || "blue30"]};
  background-color: ${({ theme, $backgroundColor }) =>
    theme.colors[$backgroundColor || "green20"]};
  padding: ${({ $padding }) => $padding || "0 0.4rem"};
  margin: ${({ $margin }) => $margin || "0"};
  font-family: ${({ $fontFamily }) => $fontFamily || "inherit"};
  border-radius: ${({ $borderRadius }) => $borderRadius || 0};
  font-weight: ${({ $fontWeight }) => $fontWeight || "normal"};
`;

export const tooltipStyle = css`
  color: #1b1d22;
  padding: 12px;
  border-radius: 4px;
  text-align: left;
  font-size: 14px;
  background-color: white;
`;
